import { WalkAndPunchApiClient } from 'src/proxy/api/walkandpunch-api.proxy';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class TemplateTypeStoreService {
  _templateTypes$ = new BehaviorSubject<any[]>(null);

  constructor(private customTemplateService: WalkAndPunchApiClient) {}

  loadTemplateSources() {
    return this.customTemplateService.v1CustomTemplateGetSourcesGET();
  }

  get templateTypes() {
    return this._templateTypes$.value;
  }

  set templateTypes(data: any[]) {
    this._templateTypes$.next(data);
  }

  get templateTypes$() {
    return this._templateTypes$;
  }
}
